import React, {useState} from "react";
import { 
    List, 
    Datagrid, 
    TextField,
    TopToolbar,
    DateField, 
    ReferenceField,
    Button,
    Filter,
    TextInput,
} from 'react-admin';
import AmountField from "../../Common/AmountField";
import SideBar from "../../Common/SideBar";
import AdminSideFilter from "../Filters/AdminSideFilter";
import ContentFilter from '@material-ui/icons/FilterList';
import CsvExporter from "../../Common/CsvExporter";
import CustomPagination from "../../Common/Pagination";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import archivedTabs from "../../../Dictionaries/archived";



export const AdminBankTransactionList = (props) => {
    const [showFilter, setShowFilter] = useState(false);
    const [pfilter, setPfilter] = useState({archived: false});
    const [tabs] = useState(archivedTabs);
    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const handleTabsChange = (event, value) => {
        setActiveTab(value)
        const c = tabs.find(x => x.id == value)
        setPfilter(c.value === null ? {}: {archived: c.value})
    };


    const AListActions = (props) => (
        <TopToolbar>
            <Button label="Filter" onClick={()=> setShowFilter(true)}><ContentFilter/></Button>
            <CsvExporter />
        </TopToolbar>
    );


    return (
    <List {...props} 
        bulkActionButtons={false} 
        title="Transactions" 
        filter={pfilter}
        empty={false}
        filters={
            <Filter>
                <TextInput label="Search" source="q" alwaysOn /> 
                <SideBar flag={showFilter} flagSetter={setShowFilter} alwaysOn>
                    <AdminSideFilter />
                </SideBar>
            </Filter>
        } 
        actions={<AListActions />}
        sort={{ field: 'created_at', order: 'DESC' }}
        pagination={<CustomPagination />}
    >
        <>
        <Tabs
            fullWidth
            left
            value={activeTab}
            indicatorColor="primary"
            onChange={handleTabsChange}
        >
            {tabs.map(choice => (
                <Tab
                    key={choice.id}
                    label={choice.name}
                    value={choice.id}
                />
            ))}
        </Tabs>
        <Datagrid >
            <ReferenceField label="Team" source="account_id" reference="account">
                <ReferenceField source="team_id" reference="team">
                    <TextField source="pp_id" />
                </ReferenceField>
            </ReferenceField>
            <TextField source="label" sortable={false}/>
            <DateField label="created" source="created_at" showTime={true} />
            <DateField label="completed" source="completed_at" showTime={true} />
            <ReferenceField label="Account" source="account_id" reference="account">
                <TextField source="code" />
            </ReferenceField>
            <ReferenceField label="Account desc" source="account_id" reference="account">
                <TextField source="description" />
            </ReferenceField>
            <AmountField source="amount" options={{ style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }} scale={2}/>
            <TextField source="currency" />
            <TextField source="status" />
            <TextField source="card" />
        </Datagrid>
        </>
    </List>)
};